import to from '@/utils/to.js';
import { getImageBtnAuth, getFolderBtnAuth } from '@/views/ipp/ipp-view-detail/components/RoiBrowser/utils.js';
import { DEFAULT_TAB } from '@/views/ipp/ipp-view-detail/config.js';
import { cloneDeep } from 'lodash';
// 导入 TimeIntervalSplitter 类
import TimeIntervalSplitter from '@/utils/time-splitter.js';

// roi 浏览器
export const roi = {
  data() {
    return {};
  },
  created() {},
  methods: {
    // 收藏分类
    async onCollectFolder({ id: folder_id, title: folder_name, op_type }) {
      const { ipp_id } = this.$route.query;
      const { category_id } = this.pageValue;
      const { group_id } = JSON.parse(localStorage.getItem('ipp_list')).find(x => x.id == ipp_id);
      const ipp_username = localStorage.getItem('ipp_username');

      if (op_type === 'add') {
        const [err, res] = await to(
          this.$api.proxy_add_collect_folders({
            group_id,
            category_id,
            folder_id,
            folder_name,
            ipp_id,
            userId: ipp_username
          })
        );
        if (err) return this.$message.error('操作失败');
        this.$message.success('操作成功');
      } else if (op_type === 'minus') {
        const [err, res] = await to(
          this.$api.proxy_delete_collect_folders({
            group_id,
            category_id,
            folder_id,
            folder_name,
            ipp_id,
            userId: ipp_username
          })
        );
        if (err) return this.$message.error('操作失败');
        this.$message.success('操作成功');
      }

      this.init();
    },

    // 修改文件排序类型
    onChangeSortType() {
      const sorttype = this.pageValue.sorttype === 'asc' ? 'desc' : 'asc';
      this.$emit('update', { ...this.pageValue, sorttype });
      this.$nextTick(() => {
        this.init();
      });
    },

    // 修改文件排序条件
    onChangeFileSortKey(diysort) {
      this.$emit('update', { ...this.pageValue, diysort });
      this.$nextTick(() => {
        this.init();
      });
    },

    // 修改文件夹排序类型
    onChangeFolderSortType() {
      this.$emit('update', { ...this.pageValue, folder_sorttype: this.pageValue.folder_sorttype === 'asc' ? 'desc' : 'asc' });
      this.$nextTick(() => {
        // this.onSortFolder();
        this.onGetFolder();
      });
    },

    // 修改文件夹排序条件
    onChangeFolderSortKey(folder_diysort) {
      this.$emit('update', { ...this.pageValue, folder_diysort });
      this.$nextTick(() => {
        // this.onSortFolder();
        this.onGetFolder();
      });
    },

    // 文件夹排序
    onSortFolder() {
      const arr = cloneDeep(this.pageData);
      const { folder_diysort, folder_sorttype, category_id } = this.pageValue;
      if (folder_diysort === 'count') {
        if (folder_sorttype === 'asc') {
          this.pageData = arr.sort((a, b) => a.count - b.count);
        } else if (folder_sorttype === 'desc') {
          this.pageData = arr.sort((a, b) => b.count - a.count);
        }
      } else if (folder_diysort === 'collect') {
        if (folder_sorttype === 'asc') {
          this.pageData = arr.sort((a, b) => a.collect_status - b.collect_status);
        } else if (folder_sorttype === 'desc') {
          this.pageData = arr.sort((a, b) => b.collect_status - a.collect_status);
        }
      } else if (folder_diysort === 'title') {
        if (folder_sorttype === 'asc') {
          if (category_id === -5) {
            this.pageData = arr.sort((a, b) => a.id - b.id);
          } else if (category_id === -1 || category_id === -2 || category_id === -4) {
            this.pageData = arr.sort(
              (a, b) =>
                (Number(a.title.substring(0, 3)) === NaN ? 0 : Number(a.title.substring(0, 3))) -
                (Number(b.title.substring(0, 3)) === NaN ? 0 : Number(b.title.substring(0, 3)))
            );
          } else {
            this.pageData = this.$tool.sortByFirstLetter(arr, 'title', 'desc');
          }
        } else if (folder_sorttype === 'desc') {
          if (category_id === -5) {
            this.pageData = arr.sort((a, b) => b.id - a.id);
          } else if (category_id === -1 || category_id === -2 || category_id === -4) {
            this.pageData = arr.sort(
              (a, b) =>
                (Number(b.title.substring(0, 3)) === NaN ? 0 : Number(b.title.substring(0, 3))) -
                (Number(a.title.substring(0, 3)) === NaN ? 0 : Number(a.title.substring(0, 3)))
            );
          } else {
            this.pageData = this.$tool.sortByFirstLetter(arr, 'title', 'asc');
          }
        }
      }
    },

    // ✅ 新增分类（文件夹）【前置】
    async onBeforeAddFolder() {
      const { category_id } = this.pageValue;
      console.log('新增分类（文件夹）【前置】', category_id, this.pageData);
      const maxNumber = this.pageData[this.pageData.length - 1].title.substring(0, 3);
      const [err, res] = await to(
        this.$prompt(
          [-1, -4].includes(category_id) ? this.$t('components.DialogSelecFolder.348250-5') : this.$t('components.DialogSelecFolder.348250-5-1'),
          '提示',
          [-1, -4].includes(category_id)
            ? {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^\d{3}[\u4e00-\u9fa5a-zA-Z0-9_-]+$/,
                inputErrorMessage: '命名不符合规范',
                inputPlaceholder: category_id === -4 ? maxNumber : ''
              }
            : {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
              }
        )
      );
      if (err) return;
      const { value: title } = res;

      if (!title) {
        return this.$message.error('请填写分类名称');
      }

      // // 校验名称是否符合规范
      // if (!/^\d{3}[\u4e00-\u9fa5a-zA-Z0-90-9_-]+$/.test(title) && [-1, -4].includes(category_id)) {
      //   return this.$message.error('命名不符合规范');
      // }

      if (category_id === -1) {
        this.onAddXcubeFolder({ title, category_id });
      } else {
        this.onAddFolder({ title, category_id });
        // 人工识别新建需要同步到团队参考库
        // if (category_id === -4) this.onAddFolder({ title, category_id: -2 });
      }
    },

    // ✅ 新增分类（文件夹）
    async onAddFolder({ title, category_id }) {
      const { ipp_id } = this.$route.query;
      const { EChartsBarForm } = this.form;
      const { Roi_time_s, Roi_time_e } = EChartsBarForm || {};
      if (!title) return this.$message.error('分类名称不允许为空');
      const { label } = DEFAULT_TAB().find(x => x.value == category_id);
      // 获取目标tab下面的全部分类
      const params1 = {
        category_id,
        Roi_time_s,
        Roi_time_e
      };
      const [err1, res1] = await to(this.$api.get_roi_folder(params1));
      if (err1) return this.$message.error('接口错误');
      let { items } = res1;
      if (!Array.isArray(items)) items = Object.keys(items).map(key => items[key]);
      const ele = items.find(x => x.title == title);
      if (ele && ele.id) {
        this.$message.error(`【${label}】已存在分类【${title}】`);
        return;
      }

      // 新建分类
      const params2 = {
        ipp_id,
        title,
        category_id
      };
      const [err2, res2] = await to(this.$api.roi_add_folder(params2));
      if (err2) return this.$message.error('操作失败');
      this.init();
      this.$message.success(`【${label}】新建分类【${title}】成功`, [1]);
    },

    // 重命名分类（文件夹）
    async onRenameFolder({ title, id, category_id }) {
      console.log('重命名分类（文件夹）');
      if (category_id === 10000) {
        const [err, res] = await to(
          this.$prompt(this.$t('components.DialogSelecFolder.348250-5-1'), this.$t('components.DialogSelecFolder.348250-14') + '  ' + title, {
            confirmButtonText: this.$t('components.DialogSelecFolder.348250-7'),
            cancelButtonText: this.$t('components.DialogSelecFolder.348250-8'),
            inputErrorMessage: this.$t('components.DialogSelecFolder.348250-9')
          })
        );

        if (err) return;

        // 判断是否有重名
        const isSameName = this.pageData.some(x => x.title == res.value);
        if (isSameName) {
          return this.$message.error(`已存在${res.value}分类，操作失败`);
        }

        const [err1, res1] = await to(this.$api.roi_change_folder({ title: res.value, id }));
        if (err1) return this.$message.error('操作失败');
        this.init();
        this.$message.success(`操作成功`);
      } else {
        const [err, res] = await to(
          this.$prompt(this.$t('components.DialogSelecFolder.348250-5'), this.$t('components.DialogSelecFolder.348250-14') + '  ' + title, {
            confirmButtonText: this.$t('components.DialogSelecFolder.348250-7'),
            cancelButtonText: this.$t('components.DialogSelecFolder.348250-8'),
            inputPattern: /^\d{3}[\u4e00-\u9fa5a-zA-Z0-9_-]+$/,
            inputErrorMessage: this.$t('components.DialogSelecFolder.348250-9')
          })
        );

        if (err) return;

        // 判断是否有重名
        const isSameName = this.pageData.some(x => x.title == res.value);
        if (isSameName) {
          return this.$message.error(`已存在${res.value}分类，操作失败`);
        }

        if (category_id === -1) {
          const [err1, res1] = await to(this.$api.roi_change_folder({ title: res.value, id }));
          if (err1) return this.$message.error('操作失败');
        } else if (category_id === -3) {
          const [err1, res1] = await to(this.$api.roi_folder_rename({ title: res.value, roi_index_id: id }));
          if (err1) return this.$message.error('操作失败');
        }

        this.init();
        this.$message.success(`操作成功`);
      }
    },

    // ✅ 新增分类（文件夹）Xcube 参考库
    async onAddXcubeFolder({ title }) {
      const { ipp_id } = this.$route.query;
      const [err1, res1] = await to(this.$api.roi_index_index({ limit: 500, category_id: -1, group_id: '2303300836150399' }));
      if (err1) return this.$message.error('接口错误');
      if (res1 && res1.items && res1.items.length) {
        const ele = res1.items.find(x => x.title == title);
        if (ele && ele.id) {
          this.$message.error(`【Xcube 参考库】已存在分类【${title}】`);
          return;
        }
      }

      // 新建分类
      const [err, res] = await to(this.$api.roi_index_rsync({ title, ipp_id, category_id: -1 }));
      if (err) return this.$message.error('操作失败');
      this.init();
      this.$message.success(`【${label}】新建分类【${title}】成功`);
    },

    // 图片添加到临时分类（复制、移入、还原）
    async onImageToToolFolder(items, target_id, type = 'copy') {
      // 需要判断是否快捷方式
      const ele = this.toolFolderList.find(x => x.id == target_id);
      if (ele && ele.source == '-4') {
        this.onImagesToHIFolderByName({ items, type, title: ele.title });
        return;
      }

      const { category_id } = this.pageValue;
      const { ipp_id } = this.$route.query;
      const params = {
        items,
        folder_id: target_id,
        ipp_id
      };
      if (!target_id) delete params.folder_id;

      const query = { category_id, type, ipp_id, target_id, change_roi_labelindex: 0 };
      if (!target_id) delete params.target_id;
      if (Number(target_id) > 100000) {
        // 临时分类
        if (items && items.length) {
          if (items[0].hi != 1) {
            // AI 图片
            query.hi = 0;
          }
        }
      }
      this.loading = true;
      const [err, res] = await to(this.$api.roi_save_move(params, query));
      this.loading = false;
      if (err) return;
      this.$message.success('操作成功');
      this.selectFileKeys = [];
      if (type !== 'copy') this.init();
    },

    // 图片添加到分类(自动识别分类)
    async onImageAutoToFolder({ title, target_id, selectData, type }) {
      const { ipp_id } = this.$route.query;
      const { category_id } = this.pageValue || {};
      if (!title) return this.$message.error('目标分类名称不允许为空');
      // 获取目标 tab 下面的所有分类
      const { EChartsBarForm } = this.form;
      const { Roi_time_s, Roi_time_e } = EChartsBarForm || {};
      const params = {
        category_id: target_id,
        Roi_time_s,
        Roi_time_e
      };

      this.loading = true;
      const [err, res] = await to(this.$api.get_roi_folder(params));
      this.loading = false;
      if (err) return this.$message.error('接口错误');
      let { items } = res;
      if (!Array.isArray(items)) items = Object.keys(items).map(key => items[key]);
      const ele = items.find(x => x.title == title);
      const { label } = DEFAULT_TAB().find(x => x.value == target_id);
      if (!(ele && ele.id)) return this.$message.error(`${label} 未查询到分类 ${title}`);

      // 获取目标分类 id
      const folder_id = ele.id;

      // 操作图片
      this.loading = true;
      const [err1, res1] = await to(this.$api.roi_save_move({ items: selectData, folder_id, ipp_id }, { ipp_id, category_id, target_id, type }));
      this.loading = false;
      if (err1) return this.$message.error('接口错误');
      this.$message.success('操作成功');
      this.init();
    },

    // 【回收站】还原
    onRestoreRecycleBin() {
      if (!(this.selectFileKeys && this.selectFileKeys.length)) {
        this.$message.error('请选择需要操作的数据');
        return;
      }
      this.$elconfirm('确定还原选择的数据吗?', '操作提示').then(async () => {
        const selectData = this.getSelectData();
        this.selectFileKeys = [];
        this.loading = true;
        const [err, res] = await to(this.$api.roi_group_re_bin_restore({ items: selectData }));
        this.loading = false;
        if (err) return this.$message.error('操作失败');
        this.$message.success('操作成功');
        this.init();
      });
    },

    // 【回收站】清空
    onClearRecycleBin() {
      this.$elconfirm('确定清空回收站吗?', '操作提示').then(async () => {
        // const selectData = this.getSelectData(true); items: selectData
        const { ipp_id } = this.$route.query;
        const { group_id } = JSON.parse(localStorage.getItem('ipp_list')).find(x => x.id == ipp_id);
        const [err1, res1] = await to(this.$api.ipp_index({ group_id }));
        if (res1 && res1.items && res1.items.length) {
          const ele = res1.items.find(x => x.id == ipp_id);
          if (ele && ele.dev_id) {
            this.selectFileKeys = [];
            this.loading = true;
            const [err, res] = await to(this.$api.roi_group_re_bin_clear({ ipp_id: ele.dev_id }, 'delete'));
            this.loading = false;
            if (err) return this.$message.error('操作失败');
            this.$message.success('操作成功');
            this.init();
          } else this.$message.error('获取ippId失败');
        } else this.$message.error('获取ippId失败');
      });
    },

    // 【回收站】删除
    onDeleteRecycleBin() {
      this.$elconfirm('确定删除选中的数据?', '操作提示').then(async () => {
        const selectData = this.getSelectData();
        this.selectFileKeys = [];
        this.loading = true;
        const [err, res] = await to(this.$api.roi_group_re_bin_delete({ items: selectData }, 'delete'));
        this.loading = false;
        if (err) return this.$message.error('操作失败');
        this.$message.success('操作成功');
        this.init();
      });
    },

    // 【回收站】添加（图片）
    async onDeleteImage() {
      const { category_id } = this.pageValue;
      const { ipp_id } = this.$route.query;
      const params = {
        ids: this.getSelectData(),
        ipp_id,
        category_id
      };
      this.loading = true;
      const [err, res] = await to(this.$api.roi_group_delete(params, category_id));
      this.loading = false;
      if (err) return this.$message.error('操作失败');
      if ([-1, -2, -3].includes(category_id)) {
        this.$message.success('移除成功');
      } else this.$message.success('删除成功');
      this.init();
    },

    // 直接删除图片(Xcube)
    async onDeleteXcubeImage() {
      const { category_id } = this.pageValue;
      if (category_id !== -1) {
        this.$message.error('操作不支持');
        return;
      }
      const params = {
        ids: this.getSelectData().map(x => x.id)
      };
      this.loading = true;
      const [err, res] = await to(this.$api.roi_delete(params));
      this.loading = false;
      if (err) return this.$message.error('操作失败');
      this.$message.success('删除成功');
      this.init();
    },

    // 直接删除分类(Xcube)
    async onDeleteXcubeFolder({ id, title, category_id }) {
      this.loading = true;
      const [err, res] = await to(this.$api.roi_delete_folder(id));
      this.loading = false;
      if (err) return this.$message.error('操作失败');
      this.onDeleteFolder({ ids: [id], title, category_id });

      // this.$message.success('删除成功');
      // this.init();
    },

    // 【回收站】添加（分类）
    onDeleteFolder({ ids, title, category_id }) {
      const items = this.pageData
        .filter(x => ids.includes(x.id))
        .map(x => {
          return {
            ...x,
            selected: 1
          };
        });
      const { label } = DEFAULT_TAB().find(x => x.value == category_id) || {};
      const { ipp_id } = this.$route.query;
      const { group_id } = JSON.parse(localStorage.getItem('ipp_list')).find(x => x.id == ipp_id);

      this.$elconfirm(
        `确定是否删除 <span style="color: red;font-weight: 700;">${label}</span> 下的 <span style="color: red;font-weight: 700;">${title}</span> 分类?`,
        '操作提示',
        {
          dangerouslyUseHTMLString: true
        }
      ).then(async () => {
        this.loading = true;
        if (category_id === -4) {
          const [err, res] = await to(this.$api.roi_index_delete_folder({ ipp_id, index_id: items[0].id, group_id, category_id: -4 }));
          this.loading = false;
          if (err) return this.$message.error('操作失败');
          this.$message.success(`【${label}】删除分类【${title}】成功`);

          // 同步删除团队参考库同名分类
          // this.onDeleteSameNameGroupWare(title);

          // 同步删除临时分类同名快捷方式
          this.onDeleteSameNameToolCategory(title);
        } else {
          if (category_id === -1) {
            const [err0, res0] = await to(this.$api.roi_delete_folder(ids[0]));
            if (err0) return this.$message.error('操作失败');
          }
          const [err, res] = await to(this.$api.roi_index_batch_delete({ items }, ipp_id));
          this.loading = false;
          if (err) return this.$message.error('操作失败');
          this.$message.success(`【${label}】删除分类【${title}】成功`);
        }

        this.init();
      });
    },

    // 【临时分类】获取
    async onGetToolCategory() {
      const { ipp_id } = this.$route.query;
      const { group_id } = JSON.parse(localStorage.getItem('ipp_list')).find(x => x.id == ipp_id);
      this.toolFolderList = [];
      const [err, res] = await to(this.$api.roi_index_index({ limit: 1000, source: 1000, ipp_id, group_id }));
      const [err1, res1] = await to(this.$api.roi_index_index({ limit: 1000, source: -4, ipp_id, group_id }));
      if (err) return;
      this.toolFolderList = [...res.items, ...res1.items].map(x => {
        return {
          ...x,
          folder_id: x.id
        };
      });
    },

    // 【临时分类】新建
    async onAddToolCategory({ title, source, id }) {
      if (!title) {
        this.$message.error('临时分类名称不允许为空');
        return;
      }
      if (this.toolFolderList.map(x => x.title).includes(title)) {
        this.$message.error('临时分类名称不允许相同');
        return;
      }
      const { ipp_id } = this.$route.query;
      const params = {
        ipp_id,
        title,
        source,
        category_id: id
      };
      this.loading = true;
      const [err, res] = await to(this.$api.roi_add_folder(params));
      this.loading = false;
      if (err) return this.$message.error('操作失败');
      this.$message.success('新建成功');
      this.onGetToolCategory();
    },

    // 【临时分类】删除
    onDeleteToolCategory(tag) {
      const { ipp_id } = this.$route.query;
      this.$elconfirm(`确定是否${tag.source === '-4' ? '关闭该快捷方式' : '删除该临时分类'}?`, '提示').then(async () => {
        this.loading = true;

        if (tag.source === '1000') {
          const [err, res] = await to(this.$api.delete_temporary_folder(tag.id));
          this.loading = false;
          if (err) return this.$message.error('操作失败');
          this.$message.success('操作成功');
          const { category_id } = this.pageValue;
          if (category_id > 100000) this.onSelectTag({ label: '全部图像', value: -100 });
          this.onGetToolCategory();
        } else {
          const [err, res] = await to(this.$api.roi_index_batch_delete({ items: [{ ...tag, selected: 1 }] }, ipp_id));
          this.loading = false;
          if (err) return this.$message.error('操作失败');
          this.$message.success('操作成功');
          const { category_id } = this.pageValue;
          if (category_id > 100000) this.onSelectTag({ label: '全部图像', value: -100 });
          this.onGetToolCategory();
        }
      });
    },

    // 删除团队参考库同名分类
    async onDeleteSameNameGroupWare(title) {
      if (!title) return this.$message.error('分类名称不允许为空');
      const { ipp_id } = this.$route.query;
      const { EChartsBarForm } = this.form;
      // 获取团队参考库全部分类
      const params = {
        category_id: -2,
        Roi_time_s: EChartsBarForm.Roi_time_s,
        Roi_time_e: EChartsBarForm.Roi_time_e
      };

      const [err1, res1] = await to(this.$api.get_roi_folder(params));
      if (err1) return this.$message.error('接口错误');
      const ele = (res1.items || []).find(x => x.title == title);
      if (ele && ele.id) {
        // 删除团队参考库存在同名分类
        const items = [{ ...ele, selected: 1 }];
        const [err, res] = await to(this.$api.roi_index_batch_delete({ items }, ipp_id));
        if (err) return this.$message.error('接口错误');
        this.$message.success(`【团队参考库】删除分类【${title}】成功`);
      } else {
      }
    },

    // 删除临时分类同名快捷方式
    async onDeleteSameNameToolCategory(title) {
      const { ipp_id } = this.$route.query;
      const ele = this.toolFolderList.find(x => x.title == title);
      if (ele && ele.source == '-4') {
        this.loading = true;
        const [err, res] = await to(this.$api.roi_delete_tool_bar_folder({ ids: [ele.id] }, { id: ele.id, ipp_id }));
        this.loading = false;
        if (err) return this.$message.error('操作失败');
        this.$message.success('快捷方式已删除');
      } else {
      }
    },

    // 清空分类里面的图片
    async onClearFolderImages({ id, code }) {
      const { ipp_id } = this.$route.query;
      const { category_id } = this.pageValue;
      const { EChartsBarForm, EChartsPieForm } = this.form;
      const { sorttype, diysort } = this.pageValue || {};
      const { Roi_time_s, Roi_time_e, dataIndex, coordRange_0, coordRange_1 } = EChartsBarForm || {};

      let params = {
        id: ipp_id,
        limit: 200,
        page: 1,
        language: this.lang,

        from: EChartsPieForm.from,
        code: EChartsPieForm.code,

        coordRange_0,
        coordRange_1,
        dataIndex,
        Roi_time_s,
        Roi_time_e,

        category_id,
        folder_id: id,
        roi_index_code: code,
        roi_index_id: id,
        sorttype,
        diysort,

        type: 'empty'
      };
      if (category_id === -5) params.table = 'roi';

      this.loading = true;
      const [err, res] = await to(this.$api.move_roi_folder(params));
      this.loading = false;
      if (err) return this.$message.error('接口错误');
      this.$message.success('操作成功');
      this.init();
    },

    // 图片移入、复制到人工识别，直接根据名称匹配
    async onImagesToHIFolderByName({ items, type, title }) {
      // 先获取全部的人工识别分类
      const { ipp_id } = this.$route.query;
      const { EChartsBarForm } = this.form;
      const params = {
        category_id: -4,
        Roi_time_s: EChartsBarForm.Roi_time_s,
        Roi_time_e: EChartsBarForm.Roi_time_e
      };
      const [err, res] = await to(this.$api.get_roi_folder(params));
      if (err) return this.$message.error('接口错误');

      // 根据名称匹配分类
      const ele = (res.items || []).find(x => x.title == title);
      if (ele && ele.id) {
        const [err1, res1] = await to(
          this.$api.roi_save_move(
            { items: items, folder_id: ele.id, ipp_id },
            {
              ipp_id,
              category_id: this.pageValue.category_id,
              target_id: -4,
              type,
              folder_code: ele.code
            }
          )
        );
        if (err1) return this.$message.error('接口错误');
        this.$message.success(`已同步至【人工识别】${title}分类`);
        this.init();
      } else {
        this.$message.error(`【人工识别】未查询到${title}`);
      }
    },

    // 获取柱状图时间
    getFormatDateTimeByHistogram() {
      const { EChartsBarForm } = JSON.parse(localStorage.getItem('ipp_view_detail_form'));

      const { items, Roi_time_e: end_time, Roi_time_s: start_time, coordRange_0, coordRange_1, Roi_time } = EChartsBarForm || {};
      const { time_type, x } = items;
      let Roi_time_s = start_time;
      let Roi_time_e = end_time;

      if (Roi_time === 'range') {
        // 自定义时间
        Roi_time_s = start_time;
        Roi_time_e = end_time;
      } else if (Roi_time === '-1') {
        // 全部
        return [];
      } else {
        // 快捷时间
        Roi_time_s = start_time;
        Roi_time_e = end_time;
      }

      console.log(time_type, x);
      // 创建实例并使用
      const splitter = new TimeIntervalSplitter(Roi_time_s, Roi_time_e, x.length - 1);
      // 判断是否选中柱状图
      if (coordRange_0 !== '' && coordRange_1 === '') {
        // 选择一根
        console.log('选择一根', coordRange_0);
        // 获取单个区间
        const singleRange = splitter.getTimeRange(coordRange_0);
        console.log('单个区间:', singleRange);
        return singleRange;
      } else if (coordRange_0 !== '' && coordRange_1 !== '') {
        // 选择两根
        console.log('选择两根', coordRange_0, coordRange_1);

        // 获取连续区间
        const continuousRange = splitter.getTimeRange([coordRange_0, coordRange_1]);
        console.log('连续区间:', continuousRange);

        return continuousRange;
      } else {
        // 没有选择
        return [Roi_time_s, Roi_time_e];
      }

      return [Roi_time_s, Roi_time_e];
    }
  }
};

// roi 浏览器分页逻辑
export const roi_page = {
  data() {
    return {
      roiPagination: {
        total: 0,
        page: 1,
        limit: 200
      }
    };
  },
  created() {},
  methods: {
    handleSizeChange(e) {
      this.roiPagination = Object.assign({}, this.roiPagination, {
        limit: e
      });
      this.init();
    },

    handleCurrentChange(e) {
      this.roiPagination = Object.assign({}, this.roiPagination, {
        page: e
      });
      this.init();
    }
  }
};

// roi 浏览器拖拽逻辑
export const roi_drag = {
  data() {
    return {
      dragIndex: '',
      dragId: '',
      dragType: '',
      dragTitle: '',
      dragCode: '',
      dragBtnAuth: []
    };
  },
  created() {
    // 拖拽逻辑
    const _this = this;
    document.addEventListener('dragstart', e => {
      const [type, id, name, code] = e.target.id.split('_');
      _this.dragIndex = '';
      _this.dragType = type;
      _this.dragId = id;
      _this.dragTitle = name;
      _this.dragCode = code;

      if (type === 'image') {
        if (!(_this.selectFileKeys && _this.selectFileKeys.length)) _this.selectFileKeys = [id];
        const selectImages = _this.pageData.filter(x => _this.selectFileKeys.includes(x.id));
        _this.dragBtnAuth = getImageBtnAuth({
          selectImages,
          toolFolderList: _this.toolFolderList,
          pageValue: _this.pageValue
        });
      } else if (type === 'folder') {
        _this.dragBtnAuth = getFolderBtnAuth({ item: { id }, pageValue: _this.pageValue });
      }
    });
    document.addEventListener('dragenter', e => {
      if (_this.dragType === 'image') {
        let d = document.getElementsByClassName('drag-tags');
        for (let i = 0; i < d.length; i++) {
          d[i].style.border = '0px';
          d[i].style.boxSizing = 'border-box';
        }
        _this.dragIndex = '';
        _this.dragCode = null;

        if (e.target.dataset.index) {
          const btnKeys = (_this.dragBtnAuth || []).map(x => x.value);
          if (_this.pageValue.category_id === -1000) {
            // 【回收站】
            // 还原
            if (btnKeys.includes(61)) {
              _this.dragCode = 61;
            }
            // 删除
            if (btnKeys.includes(62)) {
              _this.dragCode = 62;
            }
          } else if (_this.pageValue.category_id === -100) {
            // 【全部图像】
            if (e.target.dataset.index === '-1' && btnKeys.includes(11)) {
              // 复制到 Xcube参考库
              _this.dragCode = 11;
            } else if (e.target.dataset.index === '-2' && btnKeys.includes(21)) {
              // 复制到 团队参考库
              _this.dragCode = 21;
            } else if (e.target.dataset.index === '-3' && btnKeys.includes(31)) {
              // 复制到 荟萃墙
              _this.dragCode = 31;
            } else if (e.target.dataset.index === '-4' && btnKeys.includes(41)) {
              // 复制到 人工识别
              _this.dragCode = 41;
            } else if (Number(e.target.dataset.index) > 100000 && btnKeys.includes(51)) {
              // 复制到 临时分类
              _this.dragCode = 51;
            } else if (e.target.dataset.index === '-1000' && btnKeys.includes(2)) {
              // 回收站
              _this.dragCode = 2;
            }
          } else if (_this.pageValue.category_id === -1) {
            // 【Xcube参考库】
            if (e.target.dataset.index === '-2' && btnKeys.includes(21)) {
              // 复制到 团队参考库
              _this.dragCode = 21;
            } else if (e.target.dataset.index === '-1000' && btnKeys.includes(13)) {
              // 移除
              _this.dragCode = 13;
            }
          } else if (_this.pageValue.category_id === -2) {
            // 【团队参考库】
            if (e.target.dataset.index === '-1' && btnKeys.includes(11)) {
              // 复制到 Xcube参考库
              _this.dragCode = 11;
            }

            if (e.target.dataset.index === '-3' && btnKeys.includes(31)) {
              // 复制到 荟萃墙
              _this.dragCode = 31;
            }

            if (e.target.dataset.index === '-4' && btnKeys.includes(41)) {
              // 复制到 人工识别
              _this.dragCode = 41;
            }

            if (Number(e.target.dataset.index) > 100000 && btnKeys.includes(51)) {
              // 复制到 临时分类
              _this.dragCode = 51;
            }
            // 取消入库
            if (e.target.dataset.index === '-1000' && btnKeys.includes(23)) {
              _this.dragCode = 23;
            }
          } else if (_this.pageValue.category_id === -3) {
            // 【荟萃墙】
            // 取消荟萃
            if (e.target.dataset.index === '-1000' && btnKeys.includes(33)) {
              _this.dragCode = 33;
            }
          } else if (_this.pageValue.category_id === -4) {
            // 【人工识别】
            // 复制到 Xcube参考库
            if (e.target.dataset.index === '-1' && btnKeys.includes(11)) {
              _this.dragCode = 11;
            }
            // 复制到 团队参考库
            if (e.target.dataset.index === '-2' && btnKeys.includes(21)) {
              _this.dragCode = 21;
            }
            // 复制到 荟萃墙
            if (e.target.dataset.index === '-3' && btnKeys.includes(31)) {
              _this.dragCode = 31;
            }
            // 移入 人工识别
            if (e.target.dataset.index === '-4' && btnKeys.includes(42)) {
              _this.dragCode = 42;
            }
            // 移入 临时分类
            if (Number(e.target.dataset.index) > 100000 && btnKeys.includes(52)) {
              _this.dragCode = 52;
            }
            // 回收站
            if (e.target.dataset.index === '-1000' && btnKeys.includes(43)) {
              _this.dragCode = 43;
            }
          } else if (_this.pageValue.category_id === -5) {
            // 【机器识别】
            // 移入人工识别
            if (e.target.dataset.index === '-4' && btnKeys.includes(42)) {
              _this.dragCode = 42;
            }
            // 移入临时分类
            if (Number(e.target.dataset.index) > 100000 && btnKeys.includes(52)) {
              _this.dragCode = 52;
            }
            // 回收站
            if (e.target.dataset.index === '-1000' && btnKeys.includes(2)) {
              _this.dragCode = 2;
            }
          } else if (_this.pageValue.category_id > 100000) {
            // 【临时分类】
            // 移入临时分类
            if (Number(e.target.dataset.index) > 100000 && btnKeys.includes(52)) {
              _this.dragCode = 52;
            }
            // 还原
            // if (btnKeys.includes(54)) {
            //   _this.dragCode = 54;
            // }
            // 回收站
            if (e.target.dataset.index === '-1000' && btnKeys.includes(53)) {
              _this.dragCode = 53;
            }
          }
          if (_this.dragCode) {
            _this.dragIndex = e.target.dataset.index;
            e.target.style.border = '3px dotted red';
            e.target.style.boxSizing = 'content-box';
          } else {
            e.target.style.border = '0px';
            e.target.style.boxSizing = 'border-box';
          }
        }
      } else if (_this.dragType === 'folder') {
        let d = document.getElementsByClassName('drag-tags');
        for (let i = 0; i < d.length; i++) {
          d[i].style.border = '0px';
          d[i].style.boxSizing = 'border-box';
        }

        const d1 = document.getElementById('tabTool');
        d1.style.border = '0px';
        d1.style.boxSizing = 'border-box';

        _this.dragIndex = '';

        if (_this.pageValue.category_id === -2) {
          // 团队参考库  支持复制到 荟萃墙
          if (e.target.dataset.index && ['-3'].includes(e.target.dataset.index)) {
            _this.dragIndex = e.target.dataset.index;
            e.target.style.border = '3px dotted red';
            e.target.style.boxSizing = 'content-box';
          }
        } else if (_this.pageValue.category_id === -4) {
          // 人工识别  支持复制到 荟萃墙、团队参考库（分类、无图片）、操作区
          if (e.target.dataset.index && ['-2', '-3', 'folder_tool'].includes(e.target.dataset.index)) {
            _this.dragIndex = e.target.dataset.index;
            e.target.style.border = '3px dotted red';
            e.target.style.boxSizing = 'content-box';
          }
        } else if (_this.pageValue.category_id === -5) {
          // 机器识别支持复制到 人工识别
          if (e.target.dataset.index && ['-4'].includes(e.target.dataset.index)) {
            _this.dragIndex = e.target.dataset.index;
            e.target.style.border = '3px dotted red';
            e.target.style.boxSizing = 'content-box';
          }
        }
      }
    });
    document.addEventListener('dragleave', e => {});
    document.addEventListener('dragend', e => {
      let d = document.getElementsByClassName('drag-tags');
      for (let i = 0; i < d.length; i++) {
        d[i].style.border = '0px';
        d[i].style.boxSizing = 'border-box';
      }
      const d2 = document.getElementById('tabTool');
      d2.style.border = '0px';
      d2.style.boxSizing = 'border-box';

      if (_this.dragIndex && _this.dragId) _this.onDragend();
    });
  }
};
